module.exports = __webpack_public_path__ + "img/23514457708d483d879f6daed5341860.24efa159.jpg";